import { Form as FinalForm } from 'react-final-form'
import { FORM_ERROR } from 'final-form'
import React, { useMemo } from 'react'
import { Segment, Header } from 'semantic-ui-react'

import { createLocalization } from './api/create'
import { CreateLocalizationActions } from './LocalizationForm/CreateLocalizationActions'
import { CreateLocalizationForm } from './LocalizationForm/CreateLocalizationForm'
import { CreateLocalizationFormType, ProductLocalizedKeys } from './form/types'
import { formatCreatePayload } from './form/formatPayload'
import { getInitialCreateValues } from './form/getInitialValues'
import { handleGenericErrors } from '../../utils/Products/errorHandler'
import { hasAnyChangesFromDefault, validateCreate } from './form/validation'
import { Localization } from '../../hooks/useLocalizations'
import { mutators } from '../../utils/mutators'
import { PATH_PRODUCTS_EDIT } from '../../consts'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

export const CreateLocalization = ({
  product,
  localizations,
}: {
  product: ProductLocalizedKeys
  localizations?: Localization[]
}) => {
  const history = useHistory()
  const initialValues: CreateLocalizationFormType = useMemo(() => {
    return getInitialCreateValues(product)
  }, [JSON.stringify(product)]) // eslint-disable-line

  const handleSubmit = async (values: CreateLocalizationFormType) => {
    if (!hasAnyChangesFromDefault(values, product)) {
      return {
        [FORM_ERROR]: {
          name: 'Change Required',
          message:
            'At least one field must be changed from the default values to save a new state.',
        },
      }
    }

    const payload = formatCreatePayload(values, product as any)

    if (!payload) return

    const [error, response] = await createLocalization(payload)

    if (response) {
      const newLocalizationId = response.data.productLocalizationId
      toast(`State-specific content created with ID ${newLocalizationId}`, {
        containerId: 'default',
        onClick: () => {
          navigator.clipboard.writeText(newLocalizationId).then(() => {
            toast('State-specific ID copied to the clipboard')
          })
        },
      })

      history.replace(
        `${PATH_PRODUCTS_EDIT}/${product?.id}/localizations/${newLocalizationId}${history.location.search}`
      )
    } else if (error) {
      handleGenericErrors(error, 'state-specific content not created')
    }
  }

  return (
    <>
      <Segment
        attached="top"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Header as="h3" style={{ margin: 0 }}>
          Create New State-Specific Content
        </Header>
      </Segment>

      <FinalForm
        mutators={mutators}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validateCreate}
      >
        {() => (
          <CreateLocalizationForm
            product={product}
            localizations={localizations}
            actions={CreateLocalizationActions}
          />
        )}
      </FinalForm>
    </>
  )
}
